import { Component, OnInit } from '@angular/core';
import { ProjectService, MEDIA_TYPE } from '../../services/project.service';
import { CurrentService } from '../../services/current.service';
import { ModalService } from '../../services/modal.service';
import { PrintService } from '../../services/print.service';
import { UserService } from '../../services/user.service';
import { TranslateService } from '../../../../node_modules/@ngx-translate/core';
import { GTM } from 'src/app/services/gtm.service';
import { CONTEXT } from 'src/app/enum/context';

@Component({
  selector: 'ng-hbm-bdi-print-medias',
  templateUrl: './print-medias.component.html'
})
export class PrintMediasComponent implements OnInit {

  totalSelectedMediaCount: number = 0;
  totalSelectedPlan2DCount: number = 0;
  totalSelectedRenderHQCount: number = 0;
  totalSelectedSnapshotCount: number = 0;

  medias: any[];

  public printLoading: boolean;
  public customerInfos: any;

  constructor(
    public project: ProjectService,
    public modalService: ModalService,
    public current: CurrentService,
    private printService: PrintService,
    private customer: UserService,
    private translate: TranslateService,
    private gtm: GTM
  ) {
    this.customerInfos = {
      name: "(N/A)",
      id: "-"
    };

    if (this.customer.userDatas) {
      if (this.customer.userDatas.otherAccount) {
        this.customerInfos.name = this.customer.userDatas.otherAccount.completeName;
        this.customerInfos.id = this.customer.userDatas.otherAccount.magentoId;
      } else {
        this.customerInfos.name = this.customer.userDatas.completeName;
        this.customerInfos.id = this.customer.userDatas.magentoId;
      }
    }


    this.project.getDetails(current.project.uuid, this.customer.applicationId).then((projectData: any) => {

      let _noCache: string = projectData.dateUpdate.replace(/[\W]+/g, "");

      this.medias = [];

      projectData.medias.snapshot.map((snapshot: any) => {
        this.medias.push({
          url: snapshot.url + "?d=" + _noCache,
          type: MEDIA_TYPE.SNAPSHOT,
          selected: false,
          selectable: true
        })
      });

      if (projectData.medias.snapshot.length === 0) {
        this.medias.push({
          url: projectData.medias.thumbnail[1].url + "?d=" + _noCache,
          type: MEDIA_TYPE.SNAPSHOT,
          selected: false,
          selectable: true
        })
      }

      projectData.medias.renderHQ.map((renderHQ: any) => {
        let _hqObj: any = {
          url: "assets/img/placeholders/bdi-project@2x.png",
          type: MEDIA_TYPE.RENDER_HQ,
          selected: false,
          selectable: false
        }

        let _img = new Image();
        _img.onload = (e: any) => {
          _hqObj.url = renderHQ.url + "?d=" + _noCache;
          _hqObj.selectable = true;
        }
        _img.onerror = (e: any) => {
          _hqObj.url = "assets/img/placeholders/bdi-hqrenders.jpg";
        }
        _img.src = renderHQ.url + "?d=" + _noCache

        this.medias.push(_hqObj)
      });

      projectData.medias.plan2D.map((plan2D: any) => {
        this.medias.push({
          url: plan2D.url + "?d=" + _noCache,
          type: MEDIA_TYPE.PLAN_2D,
          selected: false,
          selectable: true
        })
      });
    });
  }

  ngOnInit(): void {
    this.gtm.trackEvent('click', 'medias-' + this.customer.context, 'open');
  }

  selectAll() {
    this.medias.map((media: any) => {
      media.selected = media.selectable;
    });
    this.countSelectedMedia();
  }

  select(media: any) {
    if (!media.selectable) return;
    media.selected = !media.selected;
    this.countSelectedMedia();
  }

  countSelectedMedia() {
    this.totalSelectedMediaCount = 0;
    this.totalSelectedPlan2DCount = 0;
    this.totalSelectedRenderHQCount = 0;
    this.totalSelectedSnapshotCount = 0;

    this.medias.map((media: any) => {

      if (media.selected) {

        this.totalSelectedMediaCount++;

        switch (media.type) {
          case MEDIA_TYPE.PLAN_2D:
            this.totalSelectedPlan2DCount++;
            break;
          case MEDIA_TYPE.RENDER_HQ:
            this.totalSelectedRenderHQCount++;
            break;
          case MEDIA_TYPE.SNAPSHOT:
            this.totalSelectedSnapshotCount++;
            break;

          default:
            break;
        }
      }
    });
  }

  close() {
    this.gtm.trackEvent('click', 'medias-' + this.customer.context, 'close');
    this.modalService.close();
  }

  print() {
    this.gtm.trackEvent('click', 'medias-' + this.customer.context, 'print');

    this.printLoading = true;
    this.printService.reset();

    let title: string =  this.translate.instant('popins.products_list.project')
    + (this.current.project ? this.current.project.name : this.translate.instant('popins.price_info.placeholder_project'));

    this.printService.addHeader(title).then(() => {

      if (this.customer.isLogged) {
        this.printService.addText(this.translate.instant('popins.products_list.name') + this.customerInfos.name, "my-3");
        let phone = this.customer.userDatas?.otherAccount?.phone;
        this.printService.addText(this.translate.instant('popins.products_list.phone') + 
          (phone ?  phone : "") , "my-3");

        if (this.customer.userDatas?.otherAccount?.email) {
          this.printService.addText(this.translate.instant('popins.products_list.email') + this.customer.userDatas.otherAccount.email, "my-3");
        }        

        if (this.customer.userDatas?.vendor){
          this.printService.addText(
            this.translate.instant('popins.products_list.vendor') 
            + (this.customer.userDatas.firstName ? this.customer.userDatas.firstName + '.' : '')
            + (this.customer.userDatas.lastName ? this.customer.userDatas.lastName.toUpperCase()[0] : '')
            + (this.customer.userDatas?.storeId ? " (" + this.customer.userDatas.storeId + ")" : ""), "my-3");
        }
      }
      let _rightNow = new Date();
      let _dateStr = _rightNow.toISOString().slice(0, 10).split("-");
      this.printService.addText(this.translate.instant('popins.products_list.date') + _dateStr[2] + "/" + _dateStr[1] + "/" + _dateStr[0], "mt-3");

      _rightNow.setDate(_rightNow.getDate() + 30); //ajouter 30 jours
      let _newDateStr = _rightNow.toISOString().slice(0, 10).split("-");
      this.printService.addText(this.translate.instant('popins.products_list.date30') + _newDateStr[2] + "/" + _newDateStr[1] + "/" + _newDateStr[0], "mt-3 mb-5");

      let _imgToLoadCount = 0;
      let _imgLoaded = 0;

      this.medias.map((media: any) => {

        if (media.selected) {
          _imgToLoadCount++;
          this.printService.addImage(media.url).then(() => {
            _imgLoaded++;
            if (_imgToLoadCount === _imgLoaded) {
              this.printService.print();
              this.printLoading = false;
            }
          });
          this.printService.addPageBreak();
        }
      });
    });
  }
}
